// components/WhoWeAreSection.js
import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Container } from '../styles/StyledComponents';

// Add the same padding as FounderStorySection
const SectionWrapper = styled.section`
  padding: 100px 2rem;
  background: #000000;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 3rem 1rem;        // matches FounderStorySection mobile padding
  }

   @media (max-width: 480px) {
    padding: 60px 2rem;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
  width: 100%;
  overflow: hidden;
`;

const Square = styled(motion.div)`
  width: 15px;
  height: 15px;
  background: #ffffff;
  flex-shrink: 0;
`;

const Line = styled(motion.div)`
  flex: 1;
  height: 1px;
  background: #ffffff;
`;

const Title = styled(motion.h2)`
  font-size: 18px;
  color: #ffffff;
  margin: 0;
  white-space: nowrap;
  font-weight: 600;
  letter-spacing: 0.5px;
`;

const TitleTwo = styled(motion.h2)`
  font-size: clamp(3rem, 8vw, 2.5rem);
  font-weight: 700;
  line-height: 1.02;
  letter-spacing: -2.5px;
  color: #ffffff;

  @media (max-width: 1024px) {
    font-size: 66px;
  }
  @media (max-width: 768px) {
    font-size: 48px;
    margin-bottom: 4rem;
  }
`;

const Text = styled(motion.p)`
  text-align: left;
  max-width: 65%;
  margin: 0 0 2rem 0;
  color: #ffffff;
  font-size: 21px;
  font-weight: 500;
  line-height: 1.5;
  opacity: 0.95;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

const WhoWeAreSection = () => {
  // Animation variants (unchanged)
  const titleContainerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        when: "beforeChildren",
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  const lineVariants = {
    hidden: { scaleX: 0 },
    visible: {
      scaleX: 1,
      transition: { duration: 1.2, ease: "easeInOut", delay: 0.6 },
    },
  };

  const textVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1, ease: "easeOut", delay: 0.8 },
    },
  };

  return (
    <SectionWrapper
      id="who-we-are"
      as={motion.section}
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.8 }}
    >
      <Container>
        <motion.div
          variants={titleContainerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          <TitleContainer>
            <Square variants={itemVariants} />
            <Title variants={itemVariants}>Who We Are</Title>
            <Line
              variants={lineVariants}
              style={{ originX: 0 }}
            />
          </TitleContainer>
        </motion.div>

        <Text
          variants={textVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          <br/>
          <TitleTwo>Welcome to <br/>Start Something Different Global</TitleTwo>
          We are a global search and selection agency who build high impact teams for growth in Luxury, Fashion, Creative and Digital Innovation industries. From start-ups to established corporations, we connect visionary brands with transformational talent across the globe.
          <br/><br/>
          <TitleTwo>Our mission?</TitleTwo>
          To make recruitment transformational, not transactional.
        </Text>
      </Container>
    </SectionWrapper>
  );
};

export default WhoWeAreSection;